import React from 'react';

import { useLocale } from '$contexts/locale';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/global.d.ts').LocaleSelector}
 */
const LocaleSelector = () => {
    const {
        currentLocale,
        locales,
        setCurrentLocale,
        translationPages
    } = useLocale();

    const handleLocale = (newLocale) => {
        if (!newLocale) { return; }
        setCurrentLocale(newLocale);
        const isDefault = locales && Object.keys(locales).findIndex((key) => locales[key].code === newLocale.code) === 0;
        const newPage = translationPages?.edges?.find((edge) => edge.node?.locale === newLocale.code).node;
        let url;
        if (newPage) {
            url = newPage.url;
        } else {
            if (isDefault) {
                url = '/';
            } else {
                url = `/${newLocale.urlCode}`;
            }
        }
        window.location.href = url;
    };

    return (
        <div className='flex'>
            {locales && Object.keys(locales).map((localeKey) => {
                const localeItem = locales[localeKey];
                const isCurrent = localeItem.code === currentLocale?.code;

                if (isCurrent) {
                    return (
                        <div
                            className='uppercase border-r border-black last:border-0 px-12'
                            key={localeKey}>
                            {localeItem.urlCode}
                        </div>
                    );
                } else {
                    return (
                        <button
                            className='uppercase underline border-r border-black last:border-0 px-12'
                            key={localeKey}
                            onClick={() => handleLocale(localeItem)}
                            type='button'>
                            {localeItem.urlCode}
                        </button>
                    );
                }
            })}
        </div>
    );
};

/* ========================================================================= */
/* Export(s) */
/* ========================================================================= */

export default LocaleSelector;
